enum AttributeKey {
    SecondaryStoreCode = 'SECONDARY_STORE_CODE',
}

export default AttributeKey
